
























































































import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'AddLinks',
  props: {
    links: Array,
  },
  setup(props, { root, emit }) {
    const linkRules = [
      (v: string) => {
        let isValid = true
        try {
          const url = new URL(v)
        } catch (e) {
          isValid = false
        }
        return isValid || root.$t('mediaItem.form.error.linkInvalid')
      },
    ]

    const addLink = () => {
      emit('update:links', [...props.links, ''])
    }

    const deleteLink = (index: number): void => {
      emit('update:links', [
        ...props.links.slice(0, index),
        ...props.links.slice(index + 1),
      ])
    }

    return { linkRules, addLink, deleteLink }
  },
})
